import { apiUrl2 } from '../../../settings'

export const addDiwaliGiftPhotosUrl = () => {
  return apiUrl2 + '/addDiwaliGiftPhotos'
}

export const getAllAgentOfMarketingUserUrl = () => {
  return apiUrl2 + '/getAllAgentOfMarketingUser'
}
